<sirius-spacer></sirius-spacer>
<sirius-grid>
    <div class="sir-header">
        <sirius-heading
            text="{{
                query ? ('search.title.query' | translate: { query: query }) : ('search.title.default' | translate)
            }}"
            textStyleSize="m"></sirius-heading>

        <span
            [ngStyle]="{ opacity: (hasLoaded$ | async) ? '1.0' : '0.0' }"
            class="sir-number-of-results sir-text-style-paragraph-s-default">
            {{
                'search.numberOfResults'
                    | translate
                        : {
                              totalResults: numberOfResults,
                          }
            }}
        </span>
    </div>
    <sirius-search
        tabindex="-1"
        [busy]="fetching$"
        [value]="searchQuery"
        (submitEvent)="onSearch($event)"
        (clearEvent)="onSearch($event)"
        [rounded]="true">
    </sirius-search>
    @if ((hasLoaded$ | async) && (!items || items.length === 0)) {
        <span class="sir-no-results sir-text-style-paragraph-l-bold">{{ 'search.noResults' | translate }}</span>
    }
    @if (items) {
        <div class="sir-search-results">
            @for (item of items; track $index) {
                <a [href]="item.link" target="_blank">
                    <article>
                        <header class="sir-text-style-paragraph-l-bold">
                            {{ item.title }}
                        </header>
                        <p class="sir-text-style-paragraph-m-default">{{ item.snippet }}</p>
                        <footer class="sir-text-style-button-m-default">
                            {{ item.link }}
                        </footer>
                    </article>
                </a>
            }
        </div>
    }
    @if (paging && paging.numberOfPages > 1) {
        <sirius-pagination [config]="paging" (selectionChange)="onPageChange($event.currentPage)"> </sirius-pagination>
    }
</sirius-grid>
